export const mean = (xs: readonly number[]): number =>
  xs.length === 0 ? NaN : xs.reduce((a, b) => a + b, 0) / xs.length;

export const sd = (xs: readonly number[]): number => {
  if (xs.length < 2) return NaN;
  const m = mean(xs);
  return Math.sqrt(xs.reduce((a, b) => a + (b - m) ** 2, 0) / (xs.length - 1));
};

export const harmonicMean = (xs: readonly number[]): number =>
  xs.length === 0 ? NaN : xs.length / xs.reduce((a, b) => a + 1 / b, 0);

export function quantile(xs: readonly number[], q: number): number {
  if (xs.length === 0) return NaN;
  const s = [...xs].sort((a, b) => a - b);
  const pos = (s.length - 1) * q;
  const lo = Math.floor(pos), hi = Math.ceil(pos);
  const a = s[lo] as number, b = s[hi] as number;
  return a + (b - a) * (pos - lo);
}

export const median = (xs: readonly number[]): number => quantile(xs, 0.5);

export function pearson(xs: readonly number[], ys: readonly number[]): number {
  const n = Math.min(xs.length, ys.length);
  if (n < 3) return NaN;
  const mx = mean(xs.slice(0, n)), my = mean(ys.slice(0, n));
  let num = 0, dx = 0, dy = 0;
  for (let i = 0; i < n; i += 1) {
    const a = (xs[i] as number) - mx, b = (ys[i] as number) - my;
    num += a * b; dx += a * a; dy += b * b;
  }
  return dx === 0 || dy === 0 ? NaN : num / Math.sqrt(dx * dy);
}

/** Spearman-Brown: 반분 상관 → 전체 길이 신뢰도 */
export const spearmanBrown = (r: number): number => (2 * r) / (1 + r);

export const finiteOrNull = (x: number): number | null => (Number.isFinite(x) ? x : null);
